import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5bec1f7c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "index_container"
};
import { useStore } from 'vuex';
import Chat from '@/views/chat/index.vue';
import LeftSlide from '@/views/leftSlide/index.vue';
import RightSlide from '@/views/rightSlide/index.vue';
import roleHooks from '@/hooks/roleHooks';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const store = useStore();
    const {
      isShowLeft,
      isShowRight
    } = roleHooks();
    // 点击出现左边列表时候 进行判断 是否登录
    //  如果已经登录提前请求角色列表 存入vuex
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_Transition, {
        name: "fade"
      }, {
        default: _withCtx(() => [_unref(isShowLeft) ? (_openBlock(), _createBlock(LeftSlide, {
          key: 0
        })) : _createCommentVNode("", true)]),
        _: 1
      }), _createVNode(_Transition, {
        name: "fadeRight"
      }, {
        default: _withCtx(() => [_unref(isShowRight) ? (_openBlock(), _createBlock(RightSlide, {
          key: 0
        })) : _createCommentVNode("", true)]),
        _: 1
      }), _createVNode(Chat)]);
    };
  }
});